import { render, staticRenderFns } from "./GradingDetail.vue?vue&type=template&id=4fd443c6"
import script from "../../controllers/grading/grading-detail.js?vue&type=script&lang=js&external"
export * from "../../controllers/grading/grading-detail.js?vue&type=script&lang=js&external"
import style0 from "./GradingDetail.vue?vue&type=style&index=0&id=4fd443c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports